import React from 'react';
import TourOperatorLogoBadgeBase from '../TourOperatorLogoBadge';
import type { BadgeContext } from '../types';

/** Adapts TourOperatorLogoBadge to the BadgeContext interface */
const TourOperatorLogoBadge = ({ dealCard }: BadgeContext) => (
  <TourOperatorLogoBadgeBase code={dealCard?.product?.accommodation?.toCode} />
);

export default TourOperatorLogoBadge;
